export const TERMS_AND_CONDITIONS_IDENTIFIERS = {
  eagleshare_renter_terms: 'eagleshare_renter_terms',
  eagleshare_owner_terms: 'eagleshare_owner_terms',
  eagleshare_terms_of_service: 'eagleshare_terms_of_service',
  eagleshare_privacy_policy: 'eagleshare_privacy_policy',
  eagleshare_roadside_assistance_policy: 'es_roadside_assistance_policy',
};

export const ESSENTIALS_IDENTIFIERS = {
  motorcycle_rental_license_requirements: 'motorcycle_rental_license_requirements',
  cancellation_terms_policies: 'cancellation_terms_policies',
  list_of_exclusions: 'list_of_exclusions',
  eagleshare_insurance_and_protection_plan: 'eagleshare_insurance_and_protection_plan',
  eagleshare_damage_policy: 'eagleshare_damage_policy',
  commercial_owner_protection_policy: 'commercial_owner_protection_policy',
};

export const TERMS_AND_CONDITIONS_URLS = {
  eagleshare_renter_terms: 'eagleshare-renter-terms',
  eagleshare_owner_terms: 'eagleshare-owner-terms',
  eagleshare_terms_of_service: 'eagleshare-terms-of-service',
  eagleshare_privacy_policy: 'eagleshare-privacy-policy',
  es_roadside_assistance_policy: 'eagleshare-roadside-assistance-policy',
};

export const ESSENTIALS_URLS = {
  motorcycle_rental_license_requirements: 'motorcycle-rental-license-requirements',
  cancellation_terms_policies: 'cancellation-terms-policies',
  list_of_exclusions: 'list-of-exclusions',
  eagleshare_insurance_and_protection_plan: 'eagleshare-insurance-and-protection-plan',
  eagleshare_damage_policy: 'eagleshare-damage-policy',
  commercial_owner_protection_policy: 'commercial-owner-protection-policy',
};

export const INFO_PAGES_TYPES = {
  essentials: 'essentials',
  terms_and_conditions: 'terms_and_conditions',
};
